import React, { useState } from 'react';
import Modal from '../UI/Modal';
import Button from '../UI/Button';

export default function ImprovementModal({ isOpen, onClose, suggestions = [], onApply }) {
	const [selected, setSelected] = useState({});
	const allSelected = suggestions.length && Object.values(selected).every(Boolean);

	function toggleAll() {
		if (allSelected) {
			setSelected({});
		} else {
			const m = {};
			suggestions.forEach((_, i) => (m[i] = true));
			setSelected(m);
		}
	}

	function apply() {
		const chosen = suggestions.filter((_, i) => selected[i]);
		onApply?.(chosen);
		onClose?.();
	}

	return (
		<Modal isOpen={isOpen} onClose={onClose} title="Apply Suggestions" size="lg">
			<div className="mb-2">
				<button className="text-sm text-primary-600 underline" onClick={toggleAll}>
					{allSelected ? 'Deselect All' : 'Select All'}
				</button>
			</div>
			<div className="max-h-80 overflow-auto space-y-2">
				{(suggestions || []).map((s, i) => (
					<label key={i} className="flex items-start gap-2">
						<input type="checkbox" checked={!!selected[i]} onChange={(e) => setSelected((m) => ({ ...m, [i]: e.target.checked }))} />
						<span className="text-sm">{typeof s === 'string' ? s : s?.title || ''}</span>
					</label>
				))}
			</div>
			<div className="mt-3 flex justify-end gap-2">
				<Button variant="ghost" onClick={onClose}>
					Cancel
				</Button>
				<Button onClick={apply}>Apply Selected</Button>
			</div>
		</Modal>
	);
}


